import { useQuery } from "@tanstack/react-query";
import cmsClient from "src/services/cmsClient";

const fetchAllYearsForObservationForm = async (formId: number) => {
	const response = await cmsClient.get<CMSPaginatedData<{ year: number }>>(
		"/observations/years/",
		{
			params: { form: formId }
		}
	);

	return response.data;
};

const useObservationFormYears = (formId: number) => {
	const query = useQuery(["observation-form-years", formId], () =>
		fetchAllYearsForObservationForm(formId)
	);

	return query;
};

export default useObservationFormYears;
